import React from "react";
import { useNavigate } from "react-router-dom";

/* ── JepTags Logo (shield with J) — same as MarketingPage ── */
const Logo = ({ size = 38 }: { size?: number }) => (
  <svg width={size} height={size} viewBox="0 0 140 140" fill="none">
    <defs>
      <linearGradient id="about-ng" x1="30" y1="15" x2="110" y2="125">
        <stop offset="0%" stopColor="#00FFE0" />
        <stop offset="50%" stopColor="#00E5CC" />
        <stop offset="100%" stopColor="#22D97F" />
      </linearGradient>
    </defs>
    <rect width="140" height="140" rx="30" fill="#0F2140" />
    <path d="M70 18L28 37v32c0 26 42 45 42 45s42-19 42-45V37L70 18z" fill="none" stroke="url(#about-ng)" strokeWidth="4" />
    <circle cx="70" cy="60" r="16" fill="none" stroke="url(#about-ng)" strokeWidth="2.5" opacity="0.35" />
    <text x="70" y="68" textAnchor="middle" fontFamily="Sora,sans-serif" fontWeight="800" fontSize="20" fill="url(#about-ng)">J</text>
  </svg>
);

/* ── SVG Icons ─────────────────────────────────────────────── */
const Ico = {
  shield: <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M12 2L4 6.5v5c0 5.25 8 9.5 8 9.5s8-4.25 8-9.5v-5L12 2z" /></svg>,
  globe: <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><circle cx="12" cy="12" r="10" /><path d="M2 12h20" /></svg>,
  zap: <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M13 2L3 14h9l-1 8 10-12h-9l1-8z" /></svg>,
  heart: <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M20.84 4.61a5.5 5.5 0 00-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 00-7.78 7.78L12 21.23l8.84-8.84a5.5 5.5 0 000-7.78z" /></svg>,
  target: <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><circle cx="12" cy="12" r="10" /><circle cx="12" cy="12" r="6" /><circle cx="12" cy="12" r="2" /></svg>,
  award: <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><circle cx="12" cy="8" r="7" /><path d="M8.21 13.89L7 23l5-3 5 3-1.21-9.12" /></svg>,
  mapPin: <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0118 0z" /><circle cx="12" cy="10" r="3" /></svg>,
  phone: <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M22 16.92v3a2 2 0 01-2.18 2 19.79 19.79 0 01-8.63-3.07 19.5 19.5 0 01-6-6 19.79 19.79 0 01-3.07-8.67A2 2 0 014.11 2h3a2 2 0 012 1.72c.127.96.361 1.903.7 2.81a2 2 0 01-.45 2.11L8.09 9.91a16 16 0 006 6l1.27-1.27a2 2 0 012.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0122 16.92z" /></svg>,
  mail: <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z" /><path d="M22 6l-10 7L2 6" /></svg>,
  arrowLeft: <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round"><path d="M19 12H5" /><path d="M12 19l-7-7 7-7" /></svg>,
  arrowRight: <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round"><path d="M5 12h14" /><path d="M12 5l7 7-7 7" /></svg>,
  users: <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M17 21v-2a4 4 0 00-4-4H5a4 4 0 00-4 4v2" /><circle cx="9" cy="7" r="4" /><path d="M23 21v-2a4 4 0 00-3-3.87M16 3.13a4 4 0 010 7.75" /></svg>,
  linkedin: <svg viewBox="0 0 24 24" fill="currentColor"><path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433a2.062 2.062 0 01-2.063-2.065 2.064 2.064 0 112.063 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z" /></svg>,
};

/* ── Images ─────────────────────────────────────────────────── */
const IMG = {
  hero: "https://images.unsplash.com/photo-1451187580459-43490279c0fa?w=1600&q=80",       // digital globe / connected world
  story: "https://images.unsplash.com/photo-1563013544-824ae1b704d3?w=800&q=80",           // smartphone NFC / mobile scanning
  storyOverlay: "https://images.unsplash.com/photo-1558494949-ef010cbdcc31?w=800&q=80",    // server room / tech infrastructure
  teamCEO: "https://images.unsplash.com/photo-1560250097-0b93528c311a?w=400&q=80",         // professional man in suit
  teamCTO: "https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?w=400&q=80",      // professional woman
  teamSales: "https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=400&q=80",    // professional man casual
  teamProduct: "https://images.unsplash.com/photo-1580489944761-15a19d654956?w=400&q=80",   // professional woman smile
  officeSJ: "https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?w=800&q=80",     // modern glass office building
  officeHQ: "https://images.unsplash.com/photo-1545579133-99bb5ab189bd?w=1400&q=80",       // Silicon Valley tech campus aerial
  officeHN: "https://images.unsplash.com/photo-1583417319070-4a69db38a482?w=600&q=80",     // Hanoi Vietnam
  partners: "https://images.unsplash.com/photo-1552664730-d307ca884978?w=800&q=80",        // team collaboration
};

export default function AboutPage() {
  const navigate = useNavigate();

  const team = [
    { title: "CEO & Founder", name: "James Nguyen", desc: "Visionary leader with 15+ years in technology and supply chain management. Passionate about using technology to protect brands and consumers.", img: IMG.teamCEO },
    { title: "CTO", name: "Sarah Chen", desc: "Expert in NFC/RFID technology and secure system architecture. Previously led engineering teams at major tech companies.", img: IMG.teamCTO },
    { title: "VP of Sales", name: "Michael Torres", desc: "Drives global growth strategy and enterprise partnerships. Deep expertise in SaaS sales and business development.", img: IMG.teamSales },
    { title: "VP of Product", name: "Emily Park", desc: "Shapes the product roadmap and user experience. Background in product management for authentication and security platforms.", img: IMG.teamProduct },
  ];

  return (
    <div className="about-root">
      <style dangerouslySetInnerHTML={{ __html: STYLES }} />

      {/* NAV */}
      <nav className="about-nav">
        <a href="#" className="about-nav-logo" onClick={e => { e.preventDefault(); navigate('/'); }}>
          <Logo size={36} />
          <span className="about-wm"><span className="jep">Jep</span><span className="tags">tags</span></span>
        </a>
        <button className="about-back" onClick={() => navigate(-1)}>
          <span className="about-ico-16">{Ico.arrowLeft}</span> Back
        </button>
      </nav>

      {/* HERO with background image */}
      <section className="about-hero">
        <div className="about-hero-bg" style={{ backgroundImage: `url(${IMG.hero})` }} />
        <div className="about-hero-overlay" />
        <div className="about-hero-content">
          <div className="about-badge">About JepTags</div>
          <h1>Protecting Products. <span className="grad">Building Trust.</span></h1>
          <p>JepTags is a product authentication platform on a mission to eliminate counterfeit goods worldwide. We empower brands to protect their products and give consumers confidence in every purchase.</p>
          <div className="about-ctas">
            <button className="btn-p" onClick={() => navigate('/business/register')}>
              Get Started <span className="about-ico-16">{Ico.arrowRight}</span>
            </button>
            <a href="#" className="btn-o" onClick={(e: React.MouseEvent) => { e.preventDefault(); navigate("/contact"); }}>Contact Us</a>
          </div>
        </div>
      </section>

      {/* STATS */}
      <section className="about-stats">
        {[
          { v: "5,000+", l: "Brands Protected" },
          { v: "50M+", l: "Products Verified" },
          { v: "45+", l: "Countries Served" },
          { v: "99.8%", l: "Accuracy Rate" },
        ].map((s, i) => (
          <div key={i} className="about-stat">
            <div className="about-stat-v">{s.v}</div>
            <div className="about-stat-l">{s.l}</div>
          </div>
        ))}
      </section>

      {/* OUR STORY + image */}
      <section className="about-section">
        <div className="story-grid">
          <div className="story-text">
            <h2>Our Story</h2>
            <p>JepTags was founded with a simple but powerful idea: every product should be verifiable, and every consumer should have the power to check authenticity with a single tap.</p>
            <p>Counterfeiting is a <strong>$4.2 trillion</strong> global problem that affects every industry — from luxury fashion and pharmaceuticals to electronics and food.</p>
            <p>We built JepTags to solve this at scale. Our platform combines NFC, RFID, and QR code technology with real-time analytics, consumer engagement tools, and a seamless no-app-required experience.</p>
            <p>Today, we protect over <strong>5,000 brands</strong> across <strong>45+ countries</strong>, and we're just getting started.</p>
          </div>
          <div className="story-visual">
            <div className="story-img-wrapper">
              <img src={IMG.story} alt="Mobile authentication" className="story-img main" />
              <img src={IMG.storyOverlay} alt="Technology infrastructure" className="story-img overlay" />
              <div className="story-float-card">
                <span className="sfc-icon">{Ico.shield}</span>
                <div><div className="sfc-num">50M+</div><div className="sfc-label">Scans Completed</div></div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* MISSION & VISION */}
      <section className="about-section">
        <div className="mv-grid">
          <div className="mission-card">
            <span className="mc-icon">{Ico.target}</span>
            <h3>Our Mission</h3>
            <p>To protect brands and consumers worldwide by making product authentication simple, instant, and accessible to everyone — no app required.</p>
          </div>
          <div className="mission-card">
            <span className="mc-icon">{Ico.award}</span>
            <h3>Our Vision</h3>
            <p>A world where counterfeit goods no longer exist — where every product carries a verifiable digital identity and consumers can always trust what they buy.</p>
          </div>
        </div>
      </section>

      {/* TIMELINE */}
      <section className="about-section">
        <div className="sec-hdr"><h2>Our <span className="grad">Journey</span></h2><p>From idea to global platform — here's how we got here.</p></div>
        <div className="timeline">
          {[
            { year: "2023", title: "Founded", desc: "JepTags launched with NFC-based authentication for luxury goods" },
            { year: "2024", title: "Platform Expansion", desc: "Added RFID, QR codes, analytics dashboard, and lottery system" },
            { year: "2024", title: "Global Growth", desc: "Expanded to 45+ countries, onboarded 5,000+ brands" },
            { year: "2025", title: "Enterprise & AI", desc: "AI-powered counterfeit detection, blockchain verification, enterprise APIs" },
          ].map((m, i, arr) => (
            <div key={i} className="tl-item">
              <div className="tl-left">
                <div className="tl-dot">{m.year}</div>
                {i < arr.length - 1 && <div className="tl-line" />}
              </div>
              <div className="tl-content">
                <h3>{m.title}</h3>
                <p>{m.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* VALUES */}
      <section className="about-section">
        <div className="sec-hdr"><h2>Our <span className="grad">Values</span></h2><p>The principles that guide everything we do at JepTags.</p></div>
        <div className="values-grid">
          {[
            { icon: Ico.shield, title: "Trust & Integrity", desc: "We believe every consumer deserves to know their product is genuine. Trust is the foundation of everything we build." },
            { icon: Ico.zap, title: "Innovation First", desc: "We combine NFC, RFID, and QR technology with real-time analytics to stay ahead of counterfeiters." },
            { icon: Ico.globe, title: "Global Impact", desc: "Operating across 45+ countries, building a worldwide network of product authentication." },
            { icon: Ico.heart, title: "Customer Success", desc: "From small brands to enterprise, dedicated support and tools to help every client succeed." },
          ].map((v, i) => (
            <div key={i} className="value-card">
              <div className="value-icon">{v.icon}</div>
              <h3>{v.title}</h3>
              <p>{v.desc}</p>
            </div>
          ))}
        </div>
      </section>

      {/* TEAM with photos */}
      <section className="about-section">
        <div className="sec-hdr"><h2>Meet the <span className="grad">Team</span></h2><p>A passionate team dedicated to fighting counterfeiting.</p></div>

        {/* Team group photo */}
        <div className="team-hero-img">
          <img src={IMG.partners} alt="JepTags team" />
          <div className="team-hero-overlay" />
          <div className="team-hero-text">Building the future of product authentication</div>
        </div>

        <div className="team-grid">
          {team.map((r, i) => (
            <div key={i} className="team-card">
              <div className="team-photo-wrap">
                <img src={r.img} alt={r.name} className="team-photo" />
              </div>
              <div className="team-info">
                <h3>{r.name}</h3>
                <div className="team-role">{r.title}</div>
                <p>{r.desc}</p>
                <a href="#" className="team-linkedin" onClick={e => e.preventDefault()}>
                  <span className="team-li-ico">{Ico.linkedin}</span> Connect
                </a>
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* OFFICES with city photos */}
      <section className="about-section">
        <div className="sec-hdr"><h2>Our <span className="grad">Offices</span></h2><p>Headquartered in California with operations across the globe.</p></div>

        {/* HQ Building Showcase */}
        <div className="hq-showcase">
          <div className="hq-main-img">
            <img src={IMG.officeHQ} alt="JepTags Silicon Valley Campus" />
            <div className="hq-overlay" />
            <div className="hq-label">
              <div className="hq-label-tag">Headquarters</div>
              <div className="hq-label-title">Silicon Valley, California</div>
              <div className="hq-label-sub">Where innovation meets authentication</div>
            </div>
          </div>
        </div>

        {/* Office Cards */}
        <div className="offices-grid">
          {[
            { flag: "🇺🇸", title: "USA Headquarters", addr: "2635 Cunningham Ave, California, CA 95148", phone: "+1-844-737-4799", email: "info@jeptags.com", img: IMG.officeSJ },
            { flag: "🇻🇳", title: "Asia Pacific Office", addr: "15 Dang Thuy Tram, Hanoi, Vietnam", phone: "+84-938-681-686", email: "jeptagsvn@jeptags.com", img: IMG.officeHN },
          ].map((o, i) => (
            <div key={i} className="office-card">
              <div className="office-img-wrap">
                <img src={o.img} alt={o.title} className="office-img" />
                <div className="office-img-overlay" />
                <span className="office-flag-overlay">{o.flag}</span>
              </div>
              <div className="office-info">
                <h3>{o.title}</h3>
                <div className="office-detail"><span className="office-ico">{Ico.mapPin}</span><span>{o.addr}</span></div>
                <div className="office-detail"><span className="office-ico">{Ico.phone}</span><a href={`tel:${o.phone}`}>{o.phone}</a></div>
                <div className="office-detail"><span className="office-ico">{Ico.mail}</span><a href={`mailto:${o.email}`}>{o.email}</a></div>
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* CTA */}
      <section className="about-cta-section">
        <div className="about-cta-box">
          <Logo size={48} />
          <h2>Ready to Protect Your Brand?</h2>
          <p>Join 5,000+ brands already using JepTags to authenticate their products.</p>
          <div className="about-ctas">
            <button className="btn-p lg" onClick={() => navigate('/business/register')}>Start Free Trial</button>
            <a href="#" className="btn-o lg" onClick={(e: React.MouseEvent) => { e.preventDefault(); navigate("/contact"); }}>Contact Agent</a>
          </div>
        </div>
      </section>
    </div>
  );
}

/* ══════════════════════════════════════════════════════════════
   CSS — SAME dark navy / cyan / teal theme as MarketingPage
   ══════════════════════════════════════════════════════════════ */
const STYLES = `
.about-root *,.about-root *::before,.about-root *::after{margin:0;padding:0;box-sizing:border-box}
.about-root{
  --cyan:#00E5CC;--cyan-bright:#00FFE0;--teal:#22D97F;
  --navy-deep:#030a14;--navy:#0a1628;--navy-mid:#0F2140;
  font-family:'Sora',sans-serif;background:var(--navy-deep);color:#e0f0f0;overflow-x:hidden;min-height:100vh;
}
.grad{background:linear-gradient(135deg,var(--cyan-bright),var(--cyan),var(--teal));-webkit-background-clip:text;-webkit-text-fill-color:transparent;background-clip:text}
.jep{color:var(--cyan)}.tags{color:var(--teal)}
.sec-hdr{text-align:center;margin-bottom:48px}
.sec-hdr h2{font-size:clamp(28px,4vw,44px);font-weight:800;letter-spacing:-1px;margin-bottom:12px}
.sec-hdr p{font-size:16px;color:rgba(224,240,240,0.45);max-width:520px;margin:0 auto}
.about-ico-16 svg{width:16px;height:16px}

/* NAV */
.about-nav{position:fixed;top:0;left:0;right:0;z-index:100;padding:16px 40px;display:flex;align-items:center;justify-content:space-between;backdrop-filter:blur(20px);background:rgba(3,10,20,0.85);border-bottom:1px solid rgba(0,229,204,0.06)}
.about-nav-logo{display:flex;align-items:center;gap:12px;text-decoration:none;cursor:pointer}
.about-wm{font-size:22px;font-weight:700;letter-spacing:-.5px}
.about-back{display:flex;align-items:center;gap:6px;background:none;border:1px solid rgba(0,229,204,0.15);color:rgba(224,240,240,0.6);font-family:'Sora',sans-serif;font-size:13px;padding:8px 16px;border-radius:8px;cursor:pointer;transition:all .3s}
.about-back:hover{border-color:var(--cyan);color:var(--cyan)}

/* BUTTONS */
.btn-p{padding:14px 28px;border:none;border-radius:12px;background:linear-gradient(135deg,var(--cyan-bright),var(--teal));color:var(--navy-deep);font-family:'Sora',sans-serif;font-size:15px;font-weight:700;cursor:pointer;transition:transform .3s,box-shadow .3s;display:inline-flex;align-items:center;gap:8px;text-decoration:none}
.btn-p:hover{transform:translateY(-2px);box-shadow:0 12px 40px rgba(0,229,204,0.35)}
.btn-p.lg{font-size:16px;padding:16px 36px}
.btn-o{padding:14px 28px;border:1.5px solid rgba(0,229,204,0.25);border-radius:12px;background:rgba(0,229,204,0.04);color:var(--cyan);font-family:'Sora',sans-serif;font-size:15px;font-weight:600;cursor:pointer;transition:all .3s;display:inline-flex;align-items:center;gap:8px;text-decoration:none}
.btn-o:hover{border-color:var(--cyan);background:rgba(0,229,204,0.08)}
.btn-o.lg{font-size:16px;padding:16px 36px}

/* HERO — with background image */
.about-hero{position:relative;padding:160px 40px 100px;text-align:center;overflow:hidden}
.about-hero-bg{position:absolute;inset:0;background-size:cover;background-position:center;background-repeat:no-repeat;filter:brightness(0.3) saturate(0.8)}
.about-hero-overlay{position:absolute;inset:0;background:linear-gradient(180deg,var(--navy-deep) 0%,rgba(3,10,20,0.7) 40%,rgba(3,10,20,0.85) 70%,var(--navy-deep) 100%)}
.about-hero-content{position:relative;z-index:2;max-width:720px;margin:0 auto}
.about-badge{display:inline-block;padding:8px 20px;border-radius:100px;background:rgba(0,229,204,0.08);border:1px solid rgba(0,229,204,0.15);font-size:12px;font-weight:600;letter-spacing:1.5px;text-transform:uppercase;color:var(--cyan);margin-bottom:24px}
.about-hero h1{font-size:clamp(36px,5vw,56px);font-weight:800;line-height:1.1;letter-spacing:-2px;margin-bottom:20px}
.about-hero p{font-size:17px;line-height:1.7;color:rgba(224,240,240,0.55);margin-bottom:32px;max-width:640px;margin-left:auto;margin-right:auto}
.about-ctas{display:flex;gap:16px;justify-content:center;flex-wrap:wrap}

/* STATS */
.about-stats{display:flex;justify-content:center;gap:48px;padding:48px 24px;flex-wrap:wrap;border-top:1px solid rgba(0,229,204,0.05);border-bottom:1px solid rgba(0,229,204,0.05)}
.about-stat{text-align:center}
.about-stat-v{font-size:28px;font-weight:800;font-family:'JetBrains Mono',monospace;background:linear-gradient(135deg,var(--cyan-bright),var(--teal));-webkit-background-clip:text;-webkit-text-fill-color:transparent;background-clip:text}
.about-stat-l{font-size:11px;font-weight:600;letter-spacing:1.5px;text-transform:uppercase;color:rgba(224,240,240,0.3);margin-top:4px}

/* SECTIONS */
.about-section{padding:80px 40px;max-width:1100px;margin:0 auto}

/* STORY — with image */
.story-grid{display:grid;grid-template-columns:1fr 1fr;gap:56px;align-items:center}
.story-text h2{font-size:clamp(28px,4vw,40px);font-weight:800;letter-spacing:-1px;margin-bottom:20px}
.story-text p{font-size:15px;line-height:1.7;color:rgba(224,240,240,0.5);margin-bottom:16px}
.story-text strong{color:var(--cyan)}

.story-visual{position:relative}
.story-img-wrapper{position:relative}
.story-img{border-radius:20px;width:100%;display:block}
.story-img.main{height:380px;object-fit:cover;border:1px solid rgba(0,229,204,0.08)}
.story-img.overlay{position:absolute;bottom:-24px;right:-24px;width:55%;height:200px;object-fit:cover;border:2px solid var(--navy-deep);border-radius:16px;box-shadow:0 20px 60px rgba(0,0,0,0.5)}
.story-float-card{position:absolute;top:20px;left:-20px;padding:14px 20px;border-radius:14px;background:rgba(15,33,64,0.9);border:1px solid rgba(0,229,204,0.15);backdrop-filter:blur(10px);display:flex;align-items:center;gap:12px;animation:sfFloat 4s ease-in-out infinite}
@keyframes sfFloat{0%,100%{transform:translateY(0)}50%{transform:translateY(-8px)}}
.sfc-icon{width:32px;height:32px;color:var(--cyan);display:flex}.sfc-icon svg{width:32px;height:32px}
.sfc-num{font-size:18px;font-weight:800;font-family:'JetBrains Mono',monospace;background:linear-gradient(135deg,var(--cyan-bright),var(--teal));-webkit-background-clip:text;-webkit-text-fill-color:transparent;background-clip:text}
.sfc-label{font-size:10px;letter-spacing:1px;text-transform:uppercase;color:rgba(224,240,240,0.35)}

/* MISSION / VISION */
.mv-grid{display:grid;grid-template-columns:1fr 1fr;gap:24px}
.mission-card{padding:36px;border-radius:20px;border:1px solid rgba(0,229,204,0.08);background:rgba(15,33,64,0.5);transition:all .4s}
.mission-card:hover{border-color:rgba(0,229,204,0.15);transform:translateY(-4px)}
.mc-icon{width:40px;height:40px;display:block;margin-bottom:14px;color:var(--cyan)}.mc-icon svg{width:40px;height:40px}
.mission-card h3{font-size:20px;font-weight:700;margin-bottom:10px}
.mission-card p{font-size:14px;line-height:1.7;color:rgba(224,240,240,0.45)}

/* TIMELINE */
.timeline{max-width:600px;margin:0 auto}
.tl-item{display:flex;gap:20px}
.tl-left{display:flex;flex-direction:column;align-items:center}
.tl-dot{width:48px;height:48px;border-radius:50%;background:linear-gradient(135deg,var(--cyan-bright),var(--teal));color:var(--navy-deep);display:flex;align-items:center;justify-content:center;font-size:11px;font-weight:800;font-family:'JetBrains Mono',monospace;flex-shrink:0}
.tl-line{width:2px;flex:1;background:rgba(0,229,204,0.1);margin:8px 0}
.tl-content{padding-bottom:32px}
.tl-content h3{font-size:16px;font-weight:700;margin-bottom:4px}
.tl-content p{font-size:13px;color:rgba(224,240,240,0.4);line-height:1.5}

/* VALUES */
.values-grid{display:grid;grid-template-columns:repeat(4,1fr);gap:20px}
.value-card{text-align:center;padding:32px 20px;border-radius:20px;background:rgba(15,33,64,0.5);border:1px solid rgba(0,229,204,0.06);transition:all .4s}
.value-card:hover{border-color:rgba(0,229,204,0.15);transform:translateY(-4px);box-shadow:0 20px 60px rgba(0,0,0,0.3)}
.value-icon{width:52px;height:52px;border-radius:14px;display:flex;align-items:center;justify-content:center;margin:0 auto 16px;background:rgba(0,229,204,0.08);color:var(--cyan)}
.value-icon svg{width:26px;height:26px}
.value-card h3{font-size:16px;font-weight:700;margin-bottom:8px}
.value-card p{font-size:13px;line-height:1.6;color:rgba(224,240,240,0.45)}

/* TEAM — with photos */
.team-hero-img{position:relative;border-radius:20px;overflow:hidden;margin-bottom:32px;height:280px}
.team-hero-img img{width:100%;height:100%;object-fit:cover;filter:brightness(0.6)}
.team-hero-overlay{position:absolute;inset:0;background:linear-gradient(0deg,var(--navy-deep) 0%,transparent 60%)}
.team-hero-text{position:absolute;bottom:24px;left:32px;font-size:18px;font-weight:700;z-index:2}

.team-grid{display:grid;grid-template-columns:1fr 1fr;gap:20px}
.team-card{border-radius:20px;background:rgba(15,33,64,0.5);border:1px solid rgba(0,229,204,0.06);transition:all .4s;overflow:hidden;display:flex}
.team-card:hover{border-color:rgba(0,229,204,0.15);transform:translateY(-2px)}
.team-photo-wrap{width:160px;flex-shrink:0;overflow:hidden}
.team-photo{width:100%;height:100%;object-fit:cover;filter:brightness(0.85) saturate(0.9);transition:filter .4s}
.team-card:hover .team-photo{filter:brightness(1) saturate(1)}
.team-info{padding:24px;display:flex;flex-direction:column;gap:6px}
.team-info h3{font-size:17px;font-weight:700}
.team-role{font-size:12px;font-weight:600;color:var(--cyan);letter-spacing:.5px;text-transform:uppercase}
.team-info p{font-size:13px;color:rgba(224,240,240,0.45);line-height:1.6;flex:1}
.team-linkedin{display:inline-flex;align-items:center;gap:6px;font-size:12px;color:rgba(224,240,240,0.35);text-decoration:none;transition:color .3s;margin-top:6px}
.team-linkedin:hover{color:var(--cyan)}
.team-li-ico{width:14px;height:14px;display:flex}.team-li-ico svg{width:14px;height:14px}

.hq-showcase{margin-bottom:40px}
.hq-main-img{position:relative;border-radius:24px;overflow:hidden;height:360px}
.hq-main-img img{width:100%;height:100%;object-fit:cover;filter:brightness(0.55) saturate(0.9);transition:filter .5s}
.hq-main-img:hover img{filter:brightness(0.65) saturate(1)}
.hq-overlay{position:absolute;inset:0;background:linear-gradient(135deg,rgba(3,10,20,0.6) 0%,transparent 50%,rgba(3,10,20,0.4) 100%)}
.hq-label{position:absolute;bottom:32px;left:32px;z-index:2}
.hq-label-tag{display:inline-block;padding:4px 12px;border-radius:6px;background:var(--cyan);color:var(--navy-deep);font-size:10px;font-weight:800;letter-spacing:1px;text-transform:uppercase;margin-bottom:10px}
.hq-label-title{font-size:28px;font-weight:800;letter-spacing:-1px}
.hq-label-sub{font-size:14px;color:rgba(224,240,240,0.5);margin-top:4px}

/* OFFICES — with city photos */
.offices-grid{display:grid;grid-template-columns:1fr 1fr;gap:24px;max-width:800px;margin:0 auto}
.office-card{border-radius:20px;background:rgba(15,33,64,0.5);border:1px solid rgba(0,229,204,0.06);transition:all .4s;overflow:hidden}
.office-card:hover{border-color:rgba(0,229,204,0.15)}
.office-img-wrap{position:relative;height:180px;overflow:hidden}
.office-img{width:100%;height:100%;object-fit:cover;filter:brightness(0.6) saturate(0.8);transition:filter .4s}
.office-card:hover .office-img{filter:brightness(0.75) saturate(1)}
.office-img-overlay{position:absolute;inset:0;background:linear-gradient(0deg,rgba(15,33,64,0.9) 0%,transparent 60%)}
.office-flag-overlay{position:absolute;top:16px;right:16px;font-size:28px;filter:drop-shadow(0 2px 8px rgba(0,0,0,0.5))}
.office-info{padding:24px}
.office-info h3{font-size:18px;font-weight:700;margin-bottom:14px}
.office-detail{display:flex;align-items:flex-start;gap:10px;font-size:13px;color:rgba(224,240,240,0.4);margin-bottom:10px}
.office-detail a{color:rgba(224,240,240,0.4);text-decoration:none;transition:color .3s}
.office-detail a:hover{color:var(--cyan)}
.office-ico{width:16px;height:16px;flex-shrink:0;margin-top:1px;color:rgba(224,240,240,0.25);display:flex}
.office-ico svg{width:16px;height:16px}

/* CTA */
.about-cta-section{padding:60px 40px 100px}
.about-cta-box{max-width:700px;margin:0 auto;padding:56px 48px;border-radius:28px;background:linear-gradient(135deg,rgba(0,229,204,0.06),rgba(34,217,127,0.04));border:1px solid rgba(0,229,204,0.1);text-align:center}
.about-cta-box h2{font-size:clamp(28px,4vw,40px);font-weight:800;letter-spacing:-1px;margin:16px 0 12px}
.about-cta-box p{font-size:16px;color:rgba(224,240,240,0.5);margin-bottom:28px}

/* RESPONSIVE */
@media(max-width:900px){
  .about-nav{padding:14px 20px}
  .about-hero{padding:130px 24px 70px}
  .story-grid{grid-template-columns:1fr}
  .story-img.overlay{position:relative;bottom:auto;right:auto;width:100%;margin-top:12px}
  .story-float-card{left:10px;top:10px}
  .mv-grid{grid-template-columns:1fr}
  .values-grid{grid-template-columns:1fr 1fr}
  .team-grid{grid-template-columns:1fr}
  .team-card{flex-direction:column}.team-photo-wrap{width:100%;height:200px}
  .offices-grid{grid-template-columns:1fr}
  .about-section{padding:60px 24px}
}
@media(max-width:600px){
  .values-grid{grid-template-columns:1fr}
  .about-stats{gap:24px}
  .about-cta-box{padding:36px 24px}
  .hq-main-img{height:240px}
}
`;